import React, { useEffect, useState, useRef } from 'react';
import { apiHolder as api, util } from 'api';
import { Spin, Tooltip } from 'antd';
import classname from 'classnames';
import throttle from 'lodash/throttle';
import lodashGet from 'lodash/get';
import { THUMBNAIL_SIZE } from '@web-im/common/const';
import { ERROR_FALLBACK } from '@web-im/utils/const';
import PreviousIcon from '@web-common/components/UI/Icons/svgs/PreviousSvg';
import NextIcon from '@web-common/components/UI/Icons/svgs/NextSvg';
import ShrinkIcon from '@web-common/components/UI/Icons/svgs/Shrink';
import AmplificationIcon from '@web-common/components/UI/Icons/svgs/Amplification';
import DoDownloadIcon from '@web-common/components/UI/Icons/svgs/DoDownloadSvg';
import RotateLeft from '@web-common/components/UI/Icons/svgs/RotateLeft';
import OriginalIcon from '@web-common/components/UI/Icons/svgs/Original';
import style from './imgPreview.module.scss';
import useScale from '@web-common/hooks/useScale';
import { randomString } from '@web-common/components/util/randomString';
import { convertRotateImg } from './convertRotateImg';
import ImgContextMenu from '../ContextMenu/ImgContextMenu';
import { getImageFormatFromUrl } from '@web-mail/components/ReadMail/utils/get-img-from-url';
import { downloadFile } from '@web-common/components/util/file';
import { getIn18Text } from 'api';
import { getTrackedUrl } from '@web-common/utils/download_track';
const systemApi = api.api.getSystemApi();
const eventApi = api.api.getEventApi();
const inElectron = systemApi.isElectron();
const fileApi = api.api.getFileApi();
const VIDEO_MENU = ['previous', 'next', '', 'download'];
const VIDEO_MUNU_HIDE = ['shrink', 'amplification', 'rotateLeft', 'original'];
const IMG_MENU = ['previous', 'next', '', 'download', 'shrink', 'amplification', '', 'rotateLeft', 'original'];
const ERROR_HIDE = ['download', 'shrink', 'amplification', 'rotateLeft', 'original'];
const PreviewContent = ({ data, startIndex, onCurUrlChange, downloadBanned }) => {
    var _a, _b;
    const [index, setIndex] = useState(-1);
    const [curUrl, setCurUrl] = useState('');
    const [operateDisabled, setOperateDisabled] = useState([]);
    const [imgWidth, setImgWidth] = useState('auto');
    const [imgHeight, setImgHeight] = useState('auto');
    const [maxHeight, setMaxHeight] = useState('100%');
    const [maxWidth, setMaxWidth] = useState('100%');
    const [imgMarginTop, setImgMarginTop] = useState(0);
    const [imgMarginLeft, setImgMarginLeft] = useState(0);
    const [imgWrapStyle, setImgWrapStyle] = useState({ width: 0, height: 0 });
    const [spinning, setSpinning] = useState(true);
    const [loadOriginal, setLoadOriginal] = useState(false);
    const imgRef = useRef(null);
    const videoRef = useRef(null);
    const imgWrapRef = useRef(null);
    const [rotate, setRotate] = useState(0);
    const { deltaY } = useScale();
    useEffect(() => {
        if (typeof startIndex === 'number') {
            setIndex(startIndex);
        }
    }, [startIndex]);
    useEffect(() => {
        onCurUrlChange && onCurUrlChange(curUrl);
        return () => { };
    }, [curUrl]);
    const amplificationAction = (unit = 0) => {
        if (!(imgRef === null || imgRef === void 0 ? void 0 : imgRef.current)) {
            return;
        }
        const preWidth = imgRef.current.width;
        const autUnit = unit || preWidth * 0.1;
        const halfUnit = autUnit / 2;
        const preHeight = imgRef.current.height;
        const imgCurWidth = preWidth + autUnit;
        const imgCurHeight = preHeight * (imgCurWidth / preWidth);
        const gapHeightHalf = (imgCurHeight - preHeight) / 2;
        setImgWidth(`${imgCurWidth}px`);
        setMaxWidth(`${imgCurWidth}px`);
        setMaxHeight(`${imgCurHeight}px`);
        setImgHeight(`${imgCurHeight}px`);
        setImgMarginTop(pre => {
            const res = pre - gapHeightHalf;
            if (res < 0) {
                return 0;
            }
            return res;
        });
        setImgMarginLeft(pre => {
            const res = pre - halfUnit;
            if (res < 0)
                return 0;
            return res;
        });
        const { width, height } = imgWrapStyle;
        const widthGap = imgCurWidth - width;
        const heightGap = imgCurHeight - height;
        if (widthGap > 0) {
            imgWrapRef.current.scrollLeft += halfUnit;
        }
        if (heightGap > 0) {
            imgWrapRef.current.scrollTop += gapHeightHalf;
        }
    };
    const shrinkAction = (unit = 0) => {
        if (!(imgRef === null || imgRef === void 0 ? void 0 : imgRef.current)) {
            return;
        }
        const preWidth = imgRef.current.width;
        const autUnit = unit || preWidth * 0.1;
        const halfUnit = autUnit / 2;
        const preHeight = imgRef.current.height;
        const imgCurWidth = preWidth - autUnit;
        const imgCurHeight = preHeight * (imgCurWidth / preWidth);
        const { width, height } = imgWrapStyle;
        const widthGap = imgCurWidth - width;
        const heightGap = imgCurHeight - height;
        const gapHeightHalf = (preHeight - imgCurHeight) / 2;
        if (imgCurWidth < width / 20)
            return;
        setImgWidth(`${imgCurWidth}px`);
        setMaxWidth(`${imgCurWidth}px`);
        if (widthGap > 0) {
            imgWrapRef.current.scrollLeft -= halfUnit;
        }
        else {
            imgWrapRef.current.scrollLeft = 0;
            setImgMarginLeft(pre => {
                const res = pre + halfUnit;
                return res;
            });
        }
        setImgHeight(`${imgCurHeight}px`);
        setMaxHeight(`${imgCurHeight}px`);
        if (heightGap > 0) {
            imgWrapRef.current.scrollTop -= gapHeightHalf;
        }
        else {
            imgWrapRef.current.scrollTop = 0;
            setImgMarginTop(pre => {
                const res = pre + gapHeightHalf;
                return res;
            });
        }
    };
    useEffect(() => {
        if (deltaY < 0) {
            amplificationAction(20);
        }
        if (deltaY > 0) {
            shrinkAction(20);
        }
    }, [deltaY]);
    useEffect(() => {
        let preOperateDisabled = [];
        if (loadOriginal) {
            preOperateDisabled = operateDisabled;
            setOperateDisabled(IMG_MENU);
        }
        return () => {
            if (preOperateDisabled.length > 0) {
                setOperateDisabled(preOperateDisabled);
            }
        };
    }, [loadOriginal]);
    const onLoadSource = () => {
        var _a;
        let currentDom = videoRef.current || imgRef.current;
        if (!currentDom) {
            return;
        }
        let curIndex = data.findIndex(item => item.previewUrl === currentDom.src || item.downloadUrl === currentDom.src);
        curIndex = index > -1 ? index : curIndex;
        if (((_a = data[curIndex]) === null || _a === void 0 ? void 0 : _a.type) === 'video') {
            setSpinning(false);
            return;
        }
        const currentWrap = imgWrapRef.current;
        if (!currentWrap) {
            return;
        }
        const imgWrapWidth = currentWrap.clientWidth;
        const imgWrapHeight = currentWrap.clientHeight;
        if ((currentDom === null || currentDom === void 0 ? void 0 : currentDom.src) === ERROR_FALLBACK) {
            setImgWidth('120px');
            setImgHeight('90px');
            setImgMarginTop((imgWrapHeight - 90) / 2);
            setImgMarginLeft((imgWrapWidth - 120) / 2);
            setOperateDisabled(pre => pre.filter(i => !ERROR_HIDE.includes(i)).concat(ERROR_HIDE));
            setSpinning(false);
            return;
        }
        const trueSize = lodashGet(data, `[${curIndex}].presetSize`, [])[0];
        if (trueSize && rotate === 0) {
            const newSize = Object.assign({}, trueSize);
            const proportion = newSize.width / newSize.height / (imgWrapWidth / imgWrapHeight);
            if (proportion > 1 && newSize.width >= imgWrapWidth) {
                newSize.width = imgWrapWidth;
                newSize.height = imgWrapWidth * (trueSize.height / trueSize.width);
            }
            else if (proportion < 1 && newSize.height >= imgWrapHeight) {
                newSize.height = imgWrapHeight;
                newSize.width = imgWrapHeight * (trueSize.width / trueSize.height);
            }
            else if (proportion === 1) {
                newSize.height = Math.min(imgWrapHeight, trueSize.height);
                newSize.width = Math.min(imgWrapWidth, trueSize.width);
            }
            currentDom = newSize;
        }
        const imgCurWidth = currentDom.width;
        const imgCurHeight = currentDom.height;
        setImgWrapStyle({ width: imgWrapWidth, height: imgWrapHeight });
        setImgWidth(`${imgCurWidth}px`);
        setMaxWidth(`${imgCurWidth}px`);
        setMaxHeight(`${imgCurHeight}px`);
        setImgHeight(`${imgCurHeight}px`);
        setImgMarginTop((imgWrapHeight - imgCurHeight) / 2);
        setImgMarginLeft((imgWrapWidth - imgCurWidth) / 2);
        setSpinning(false);
        setLoadOriginal(false);
    };
    useEffect(() => {
        var _a, _b, _c, _d;
        if (index === -1) {
            setSpinning(false);
            return;
        }
        const operateDisabledTemp = [];
        if (index === 0) {
            operateDisabledTemp.push('previous');
        }
        if (index === data.length - 1) {
            operateDisabledTemp.push('next');
        }
        if (((_a = data[index]) === null || _a === void 0 ? void 0 : _a.type) === 'video') {
            videoRef.current.src = (_b = data[index]) === null || _b === void 0 ? void 0 : _b.previewUrl;
            operateDisabledTemp.push(...VIDEO_MUNU_HIDE);
        }
        else {
            const curSize = lodashGet(data, `[${index}].size`, 0);
            setRotate(0);
            setSpinning(true);
            setImgWidth('auto');
            setMaxHeight('100%');
            setMaxWidth('100%');
            setImgHeight('auto');
            setImgMarginTop(0);
            setImgMarginLeft(0);
            if (curSize > THUMBNAIL_SIZE) {
                if (inElectron) {
                    const params = {
                        fileUrl: data[index].downloadUrl,
                        fileName: data[index].name || '',
                        fileSize: data[index].size || -1,
                        fileSourceType: 2,
                        dirPath: `${window.electronLib.env.userDataPath}/preview`,
                    };
                    (async () => {
                        var _a;
                        const fileInfo = await fileApi.getFileInfo(params);
                        const fileLocalPath = lodashGet(fileInfo, '[0].filePath', '');
                        if (fileLocalPath) {
                            const realPath = fileLocalPath.indexOf('/') === 0 ? fileLocalPath : `/${fileLocalPath}`;
                            setCurUrl(`cache://file${realPath}`);
                            operateDisabledTemp.push('original');
                        }
                        else {
                            setCurUrl((_a = data[index]) === null || _a === void 0 ? void 0 : _a.previewUrl);
                        }
                    })();
                }
                else {
                    setCurUrl((_c = data[index]) === null || _c === void 0 ? void 0 : _c.previewUrl);
                }
            }
            else {
                setCurUrl((_d = data[index]) === null || _d === void 0 ? void 0 : _d.previewUrl);
                operateDisabledTemp.push('original');
            }
        }
        setOperateDisabled(pre => pre.filter(i => !['previous', 'next', 'download', 'shrink', 'amplification', 'rotateLeft', 'original'].includes(i)).concat(operateDisabledTemp));
    }, [index, JSON.stringify(data.map(item => item.previewUrl))]);
    const handlerError = () => {
        var _a;
        if (!curUrl || curUrl.match(/^cache:/)) {
            setCurUrl((_a = data[index]) === null || _a === void 0 ? void 0 : _a.previewUrl);
            if (curUrl === null || curUrl === void 0 ? void 0 : curUrl.match(/^cache:/)) {
                setOperateDisabled((pre) => pre.filter((i) => i !== 'original'));
            }
            return;
        }
        setCurUrl(ERROR_FALLBACK);
    };
    const throttleReportWindowSize = throttle(onLoadSource, 200);
    useEffect(() => {
        window.addEventListener('resize', throttleReportWindowSize);
        return () => {
            window.removeEventListener('resize', throttleReportWindowSize);
        };
    }, [data, index]);
    useEffect(() => {
        const eid1 = eventApi.registerSysEventObserver('electronClose', {
            func: () => {
                setSpinning(false);
            },
        });
        return () => {
            eventApi.unregisterSysEventObserver('electronClose', eid1);
        };
    }, []);
    const createImgName = () => {
        const name = randomString();
        return `lingxi-${name}.png`;
    };
    const download = async (item) => {
        const trackedUrl = getTrackedUrl(item === null || item === void 0 ? void 0 : item.downloadUrl);
        const downloadUrl = trackedUrl || (item === null || item === void 0 ? void 0 : item.downloadUrl);
        if (!inElectron) {
            let fileName = (item === null || item === void 0 ? void 0 : item.name) || createImgName();
            if (fileName && fileName.indexOf('.') === -1) {
                fileName = `${item.name}.${item.ext || 'png'}`;
            }
            const imgBlob = await getImageFormatFromUrl(downloadUrl, item.name || '', 'blob');
            downloadFile(imgBlob, fileName || '');
            return;
        }
        let fileName = (item === null || item === void 0 ? void 0 : item.name) || createImgName();
        if ((item === null || item === void 0 ? void 0 : item.name) && (item === null || item === void 0 ? void 0 : item.name.indexOf('.')) === -1) {
            fileName = `${item.name}.${item.ext || 'png'}`;
        }
        const params = Object.assign({ fileName, fileUrl: item === null || item === void 0 ? void 0 : item.downloadUrl, fileSize: (item === null || item === void 0 ? void 0 : item.size) || -1, fileSourceType: (item === null || item === void 0 ? void 0 : item.fileSourceType) || 3 }, (trackedUrl ? { fileUrlInUse: trackedUrl } : {}));
        fileApi.saveDownload(params);
    };
    const keydownAction = (e) => {
        var _a;
        if (e.keyCode === 39 && !operateDisabled.includes('next')) {
            setIndex(i => i + 1);
        }
        if (e.keyCode === 37 && !operateDisabled.includes('previous')) {
            setIndex(i => i - 1);
        }
        if (e.keyCode === 27) {
            (_a = videoRef === null || videoRef === void 0 ? void 0 : videoRef.current) === null || _a === void 0 ? void 0 : _a.pause();
        }
        const commandKey = util.isMac() ? e.metaKey : e.ctrlKey;
        if (e.keyCode === 83 && commandKey && !e.shiftKey && !e.altKey) {
            if (downloadBanned)
                return;
            download(data[index]);
        }
    };
    useEffect(() => {
        document.body.addEventListener('keydown', keydownAction);
        return () => {
            document.body.removeEventListener('keydown', keydownAction);
        };
    }, [operateDisabled]);
    const onEnded = () => {
        videoRef.current.currentTime = 0;
    };
    const viewOriginal = async (item) => {
        if (curUrl !== item.downloadUrl && !curUrl.match(/file:/i)) {
            setSpinning(true);
            setLoadOriginal(true);
            setCurUrl(item.downloadUrl);
            setOperateDisabled((pre) => pre.concat(['original']));
            if (inElectron) {
                const params = {
                    fileUrl: item.downloadUrl,
                    fileName: item.name,
                    fileSize: item.size,
                    fileSourceType: 2,
                    dirPath: `${window.electronLib.env.userDataPath}/preview`,
                };
                fileApi.download(params);
            }
        }
    };
    const closeModal = () => { };
    const shrink = () => {
        shrinkAction();
    };
    const amplification = () => {
        amplificationAction();
    };
    const rotateLeft = () => {
        var _a;
        const preUrl = (_a = data[index]) === null || _a === void 0 ? void 0 : _a.previewUrl;
        setRotate(pre => {
            const rotateCur = (pre - 90 + 360) % 360;
            setSpinning(true);
            setImgWidth('auto');
            setMaxHeight('100%');
            setMaxWidth('100%');
            setImgHeight('auto');
            setImgMarginTop(0);
            setImgMarginLeft(0);
            if (/^https:\/\/cowork-storage-public-cdn.lx.netease.com/.test(preUrl)) {
                const imgUrl = new URL(preUrl);
                imgUrl.searchParams.append('imageView', '');
                imgUrl.searchParams.append('rotate', `${rotateCur}`);
                setCurUrl(imgUrl.toString());
            }
            else {
                convertRotateImg(preUrl, rotateCur).then(url => {
                    setCurUrl(url);
                });
            }
            return (pre - 90) % 360;
        });
    };
    const operateClick = type => {
        if (operateDisabled.includes(type))
            return;
        switch (type) {
            case 'previous':
                setIndex(i => i - 1);
                break;
            case 'next':
                setIndex(i => i + 1);
                break;
            case 'download':
                download(data[index]);
                break;
            case 'shrink':
                shrink();
                break;
            case 'amplification':
                amplification();
                break;
            case 'rotateLeft':
                rotateLeft();
                break;
            case 'close':
                closeModal();
                break;
            case 'original':
                viewOriginal(data[index]);
                break;
            default:
                break;
        }
    };
    const operate = () => {
        const curItem = data[index];
        const baseMenu = (curItem === null || curItem === void 0 ? void 0 : curItem.type) === 'video' ? VIDEO_MENU : IMG_MENU;
        const typesList = downloadBanned ? baseMenu.filter(type => type !== 'download' && type !== 'original') : baseMenu;
        const iconMap = {
            previous: {
                desc: getIn18Text('SHANGYIZHANG'),
                icon: 'previous',
                comp: PreviousIcon,
            },
            next: {
                desc: getIn18Text('XIAYIZHANG'),
                icon: 'next',
                comp: NextIcon,
            },
            shrink: {
                desc: getIn18Text('SUOXIAO\uFF08') + util.getCommonTxt() + ' -）',
                icon: 'shrink',
                comp: ShrinkIcon,
            },
            amplification: {
                desc: getIn18Text('FANGDA\uFF08') + util.getCommonTxt() + ' +）',
                icon: 'amplification',
                comp: AmplificationIcon,
            },
            download: {
                desc: getIn18Text('XIAZAI\uFF08') + util.getCommonTxt() + ' S）',
                icon: 'doDownload',
                comp: DoDownloadIcon,
            },
            rotateLeft: {
                desc: getIn18Text('XUANZHUAN'),
                icon: 'rotateLeft',
                comp: RotateLeft,
            },
            original: {
                desc: getIn18Text('CHAKANYUANTU'),
                icon: 'original',
                hidden: curItem === null || curItem === void 0 ? void 0 : curItem.nonOriginal,
                comp: OriginalIcon,
            },
        };
        return typesList.map((type, i) => {
            var _a;
            let res = React.createElement("div", { className: `${style.line}` });
            if (type) {
                const IconComp = iconMap[type].comp;
                const disableType = operateDisabled.includes(type);
                res = (React.createElement(Tooltip, { placement: "bottom", title: iconMap[type].desc },
                    React.createElement(IconComp, { hidden: iconMap[type].hidden, width: "24", height: "24", style: {
                            opacity: disableType ? '0.3' : '',
                        } })));
            }
            if ((_a = iconMap[type]) === null || _a === void 0 ? void 0 : _a.hidden) {
                return null;
            }
            return (React.createElement("div", { key: type + i, className: `${style.operateItem} ${!type ? style.operateItemNosty : ''}`, onClick: () => {
                    operateClick(type);
                } }, res));
        });
    };
    if (typeof startIndex !== 'number')
        return null;
    const isMac = inElectron && window.electronLib.env.isMac;
    return (React.createElement("div", { className: `${style.preview}` },
        React.createElement("div", { className: `${style.header} ${isMac ? style.macHeader : ''}` },
            React.createElement("div", { className: `${style.operate}` }, operate())),
        ((_a = data[index]) === null || _a === void 0 ? void 0 : _a.type) === 'video' ? (React.createElement("div", { className: `${style.contentWrap} ${style.contentVideoWrap}` },
            React.createElement("video", { ref: videoRef, className: `${style.contentVideo}`, autoPlay: true, controls: !spinning, onCanPlay: onLoadSource, onEnded: onEnded, controlsList: "nodownload" },
                React.createElement("source", { src: curUrl }),
                React.createElement("p", null, getIn18Text('NINDEHUANJINGZAN'))))) : (React.createElement("div", { ref: imgWrapRef, className: `${style.contentWrap}` },
            React.createElement(ImgContextMenu, { src: (_b = data[index]) === null || _b === void 0 ? void 0 : _b.downloadUrl, downloadBanned: downloadBanned },
                React.createElement("img", { alt: "", onLoad: onLoadSource, onError: handlerError, ref: imgRef, className: `${style.imgContent}`, src: curUrl, style: {
                        marginTop: imgMarginTop,
                        marginLeft: imgMarginLeft,
                        width: imgWidth,
                        height: imgHeight,
                        maxHeight,
                        maxWidth,
                    } })))),
        spinning && (React.createElement("div", { className: `${classname(style.spin)} img-preview-spin` },
            React.createElement(Spin, { indicator: React.createElement("i", { className: `${style.spinIcon} spin-icon` }) })))));
};
export default PreviewContent;
